import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What exactly am I buying?",
    a: "A complete Cronus Zen GPC script plus the optimized Apex Legends in-game sensitivity values for the weapon category listed. You get the .gpc file, the in-game sensitivity sheet, and a quick setup guide PDF.",
  },
  {
    q: "Which platforms work?",
    a: "Anything the Cronus Zen supports — PlayStation, Xbox, and PC with controller. The values are platform-agnostic on Zen.",
  },
  {
    q: "How do I get my files after paying?",
    a: "Right after Stripe checkout, you'll receive an automated DM in our Discord with download links. Make sure you've joined the Discord first.",
  },
  {
    q: "Do you offer refunds?",
    a: "Because these are digital downloads delivered instantly, all sales are final. If something doesn't load correctly, hit us in Discord and we'll get you sorted.",
  },
  {
    q: "What does the VIP package include?",
    a: "All 5 weapon-class value packs, lifetime updates whenever a season patch shifts the meta, a private VIP Discord channel, and 1-on-1 setup help.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative py-24 md:py-32" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 md:px-10 relative z-10">
        <div className="section-label" data-testid="faq-label">FAQ</div>
        <h2 className="font-display font-black uppercase mt-3 text-4xl md:text-5xl leading-tight" data-testid="faq-title">
          Questions, <span style={{ color: "var(--rv-red)" }}>answered</span>.
        </h2>
        <p className="text-white/65 mt-4 text-base md:text-lg leading-relaxed">
          Still curious? Drop into the Discord and we'll handle it.
        </p>

        <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              className="border border-white/10 rounded-lg px-5 bg-[#0a0a0a] data-[state=open]:border-[var(--rv-red)]/50 transition-colors"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-display font-bold uppercase tracking-tight text-left text-base md:text-lg hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 text-sm md:text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
